import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 32px 32px 24px 32px;
  border-top: 10px solid #6f4bf1;
  border-radius: 5px;

  .modal-header {
    margin-bottom: 16px;
  }

  .modal-title {
    font-size: 22px;
    font-weight: 600;
    color: #21303a;
    margin: 0 0 4px 0;
  }

  .modal-subtitle {
    font-size: 14px;
    color: #6b7c8a;
    margin: 0;
  }

  .divider {
    height: 1px;
    background-color: #e7eaed;
    margin-bottom: 20px;
  }

  .section {
    margin-bottom: 24px;
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .limit-row {
    display: flex;
    align-items: center;
    gap: 20px;

    .section-header {
      margin-bottom: 0;
    }
  }

  .section-icon {
    font-size: 20px;
    color: #21303a;
    margin-right: 5px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #21303a;
  }

  .daily-targets-table {
    border: 1px solid #e7eaed;
    border-radius: 4px;
    overflow: hidden;
  }

  .table-header-row {
    display: flex;
    background-color: #f5f7f9;
    border-bottom: 1px solid #e7eaed;
  }

  .header-cell {
    flex: 1;
    padding: 12px 8px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #21303a;
    border-right: 1px solid #e7eaed;

    &:last-child {
      border-right: none;
    }
  }

  .table-input-row {
    display: flex;
    background-color: #fff;
  }

  .input-cell {
    flex: 1;
    padding: 12px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #e7eaed;

    &:last-child {
      border-right: none;
    }
  }

  .target-input {
    width: 56px;
    height: 36px;
    padding: 6px 8px;
    border: 1px solid #c9cfd3;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;

    &:focus {
      outline: none;
      border-color: #6f4bf1;
      box-shadow: 0 0 0 2px rgba(111, 75, 241, 0.2);
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    -moz-appearance: textfield;
  }

  .weekly-limit-input {
    width: 96px;
    height: 40px;
    font-size: 16px;
  }

  .weekly-capacity {
    font-size: 16px;
    font-weight: 500;
    color: #21303a;
  }

  .capacity-note {
    font-size: 13px;
    color: #6b7c8a;
    margin-top: 4px;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e7eaed;

    .update-btn {
      background-color: #c9cfd3 !important;
      color: #6b7c8a !important;
      cursor: not-allowed !important;

      &:hover {
        background-color: #c9cfd3 !important;
      }
    }

    .update-btn-active {
      background-color: #6f4bf1 !important;
      color: #fff !important;

      &:hover {
        background-color: #5a3cc7 !important;
      }
    }
  }
`;
